import { Alert } from './types';

type AlertStoreItem = Alert & {
    id: number;
};

export const createAlertStore = () => {
    let store: AlertStoreItem[] = [];
    let subscribers = new Set<() => void>();

    const newId = () => Date.now();

    const add = (item: Alert) => {
        const newItem = { id: newId(), ...item };
        store = [...store, newItem];

        subscribers.forEach((callback) => callback());

        return newItem;
    };
    const startRemove = (id: number) => {
        // Mark the alert as exiting for animation
        store = store.map((item) =>
            item.id === id ? { ...item, isExiting: true } : item,
        );
        subscribers.forEach((callback) => callback());
    };

    const remove = (id: number) => {
        store = [...store.filter((item) => item.id !== id)];
        subscribers.forEach((callback) => callback());
    };

    const subscribe = (callback: () => void) => {
        subscribers.add(callback);
        return () => subscribers.delete(callback);
    };

    return {
        add,
        remove,
        startRemove, // Added the start remove function
        subscribe,
        getAlerts: () => store,
        getServerAlerts: () => store,
    };
};
